module.exports = __webpack_public_path__ + "media/images/tailwind/instagram-0ac66f3aa0776e76868d3bfde19a8541.png";